// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as NextImage$PorterinFeature from "./NextImage.mjs";
import * as ExploreModuleScss from "../styles/common/Explore.module.scss";

var styles = ExploreModuleScss;

function ExploreCmp(Props) {
  var onChangeCategory = Props.onChangeCategory;
  var arrow_icon = Props.arrow_icon;
  return React.createElement("div", {
              className: styles["explore-container"],
              onClick: (function (param) {
                  Curry._1(onChangeCategory, undefined);
                })
            }, React.createElement("div", {
                  className: styles["explore-text"]
                }, "Explore other services?"), React.createElement("div", {
                  className: styles.arrow
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: arrow_icon.path,
                      height: 12.0,
                      width: 7.0,
                      quality: 100.0,
                      alt: arrow_icon.alt_text
                    })));
}

var make = ExploreCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
